export enum LoginErrors {
    DB_INPUT_REQUIRED_MSG = "Database name is required",
    USER_NOT_VERIFIED_VIA_IAM = "User has not been validated via IAM.",
    USER_LOCKOUT_MSG = "Your account is temporarily locked due to multiple unsuccessful login attempts.",
    EXTERNAL_AUTH_FAILED_MSG = "There was an issue with external authentication, please try again.",
    DATABASE_VERSION_OLD_MSG = "The database is under maintenance. Please try again later.",
    UNKNOWN_DATABASE_MSG = "Unknown database.",
    INCORRECT_USERNAME_OR_PASSWORD_MSG = "Incorrect username or password.",
    NETWORK_ERROR_MSG = "We're having some trouble reaching the server. Please try again later.",
    CONNECTION_REFUSED_MSG = "Couldn't connect to the server. Please check your network connection, server name and try again.",
    SERVER_UNREACHABLE_MSG = "Server not found.",
    UNKNOWN_LOGIN_ERROR_MSG = "An error occurred during the log in process. Please try again.",
    ACCOUNT_NOT_VERIFIED = "Account not verified"
}
